// extracted by mini-css-extract-plugin
export default {"truncate":"Product_truncate__94QZL","btn-add":"Product_btn-add__XjzVX"};